import React from 'react';

function UploadProgressBar({ progress = 0 }) {
  return (
    <div className="progress-bar">
      <div
        className="progress-bar__bar"
        style={{
          width: `calc(4px + ${progress}%)`,
          borderRadius: progress === 100
            ? '4px'
            : '4px 10px 10px 4px',
        }}
      />
    </div>
  );
}

export default UploadProgressBar;



// WEBPACK FOOTER //
// ./src/components/features/dashboard/UploadProgressBar.js